import './sass/style.scss'
import './js/applify.js'
